<template>
  <div class="search-bar">
    <v-layout row justify-end align-center>
      <v-text-field
        @input="updateSearch($event)"
        :label="label"
        single-line
        prepend-inner-icon="search"
        class="search-field"
      />
    </v-layout>
  </div>
</template>

<script>
export default {
  name: "searchBar",
  props: {
    search: {
      type: String,
      required: false,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "Search...",
    },
  },
  methods: {
    updateSearch(event) {
      this.$emit("update:search", event);
    },
  },
};
</script>

<style lang="stylus" scoped>
.search-bar {
  background-color: white;
  width: 100%;
  -webkit-box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  border-bottom: 1px solid lightgrey;
  border-top: 1px solid lightgrey;
}

.search-field {
  padding-right: 20px;
  max-width: 300px;
  box-shadow: none !important;

}
</style>
